<template>
  <div>
    <BootstrapAlert :variant="block.value.type" :dismissible="false" class="mb-3">
      <div v-if="block.value.text" @click="onInternalLinkClick" v-html="block.value.text"></div>
    </BootstrapAlert>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
import {useInternalLinks} from '@/composables/useInternalLinks';
defineProps<{block: SphereBlock<'contextual_block'>}>();
const {onInternalLinkClick} = useInternalLinks();
</script>
<style lang="scss" scoped>
.alert {
  :deep(p) {
    margin-bottom: 0;
  }
}
</style>
